module.exports = __webpack_public_path__ + "img/completed-16.c6109e07.svg";